export enum PassengerSegmentCheckInStatusEnum {
    Default = "Default",
    CheckedIn = "CheckedIn",
    Boarded = "Boarded",
    NoShow = "NoShow"
}
